export const pluralLevel = (levelName: string): string => {
  if (levelName.length > 0) {
    return `${levelName}s`;
  } else {
    console.warn('levelName must have some length, yo');

    return levelName;
  }
};
